import {
  DEFAULT_SALUTATIONS,
  ISalutation,
  SALUTATION_SCHEMA,
  SALUTATIONS_SCHEMA,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IDeleteGateway, IListGateway, ISaveGateway } from '../gateways';

export class SalutationGateway
  implements
    IListGateway<never, IApiResponse<ISalutation[]>>,
    ISaveGateway<ISalutation[], IApiResponse<ISalutation[]>>,
    IDeleteGateway<string, IApiResponse<ISalutation[]>>
{
  private readonly restCallBuilder: RestCallBuilder<ISalutation[]> =
    new RestCallBuilder<ISalutation[]>(DEFAULT_SALUTATIONS);
  private readonly restCallBuilderDelete: RestCallBuilder<ISalutation[]> =
    new RestCallBuilder<ISalutation[]>([]);

  list(allChannels = false): Observable<IApiResponse<ISalutation[]>> {
    return this.restCallBuilder
      .get('/salutations/', allChannels ? { allChannels: true } : undefined)
      .validate(API_RESPONSE_SCHEMA(SALUTATIONS_SCHEMA), 'Salutation.list')
      .handleMessages()
      .build();
  }

  save(query: ISalutation[]): Observable<IApiResponse<ISalutation[]>> {
    return this.restCallBuilder
      .post('/salutations/', query)
      .validate(API_RESPONSE_SCHEMA(SALUTATIONS_SCHEMA), 'Salutation.save')
      .handleMessages()
      .build();
  }

  delete(query: string): Observable<IApiResponse<ISalutation[]>> {
    return this.restCallBuilderDelete
      .delete('/salutations/' + query)
      .validate(API_RESPONSE_SCHEMA(SALUTATIONS_SCHEMA), 'Salutation.delete')
      .handleMessages()
      .build();
  }
}
